<template>
  <div class="form-list">
    <el-form
      class="form voucher-detail-form"
      ref="form"
      label-position="right"
      label-width="160px"
    >
      <div class="form-section-title">学员</div>
      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="student.selfie"
          :nickname="student.student_name"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="data.student_id"
          :avatar-size="36"
        />
      </el-form-item>

      <div class="form-section-title">券信息</div>
      <el-form-item label="代金券 ID">{{ id }}</el-form-item>
      <el-form-item label="代金券类型">{{ data.voucher_type_name }}</el-form-item>
      <el-form-item label="面额">{{ data.amount_in_cents | toYuan }} 元</el-form-item>
      <el-form-item label="状态">
        <el-tag v-if="data.use_time" type="info" size="small">已使用</el-tag>
        <el-tag v-else-if="data.is_expired" type="danger" size="small">已过期</el-tag>
        <el-tag v-else type="success" size="small">可用</el-tag>
      </el-form-item>
      <el-form-item label="使用时间">
        <template v-if="data.use_time">{{ data.use_time | timeToYmdHi }}</template>
        <span v-else class="info-color">未使用</span>
      </el-form-item>
      <el-form-item label="有效时长">
        <template v-if="data.valid_duration_seconds > 0">{{ data.valid_duration_seconds | formatDuration }}</template>
        <span v-else-if="data.expire_time > 0">指定时间过期</span>
        <span v-else class="info-color">未设置</span>
      </el-form-item>
      <el-form-item label="过期时间">
        <template v-if="data.expire_time">{{ data.expire_time | timeToYmdHi }}</template>
        <span v-else class="success-color">永久有效</span>
      </el-form-item>
      <el-form-item label="唯一性">
        <el-tag :type="data.is_unique === 1 ? 'warning' : 'success'" size="small">
          {{ data.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}
        </el-tag>
        <div class="info-color form-item-tip">发放时的规则，后续调整以代金券类型当前设置为准</div>
      </el-form-item>
      <el-form-item label="适用课卡套餐">
        <span v-if="data.card_charge_types && data.card_charge_types.length">
          <el-tag
            v-for="ct in data.card_charge_types"
            :key="ct.id"
            size="small"
            type="info"
            style="margin-right: 4px;"
          >{{ ct.card_charge_type_name }}</el-tag>
        </span>
        <span v-else class="info-color">全部套餐适用</span>
      </el-form-item>
      <el-form-item label="限制使用门店">
        <el-tag v-if="data.is_store_limited" size="small" type="warning">{{ data.limit_store_name }}</el-tag>
        <span v-else class="info-color">全部门店</span>
      </el-form-item>
      <el-form-item v-if="data.rule" label="使用规则">{{ data.rule }}</el-form-item>

      <div class="form-section-title">发放来源</div>
      <el-form-item label="发放方式">
        <span v-for="state in findVoucherIssueType(data.issue_type)" :key="state.value">
          {{ state.name }}
        </span>
      </el-form-item>
      <el-form-item label="发放时间">{{ data.add_time | timeToYmdHi }}</el-form-item>
      <el-form-item label="归属门店">
        <span :class="{ 'info-color': !data.store_id }">{{ data.store_name || '未归属' }}</span>
      </el-form-item>
      <el-form-item v-if="data.is_app || data.store_id" label="归属依据">
        <span v-if="data.store_id">{{ data.store_source_name }}</span>
        <span v-else class="info-color">尚未归属，用券办卡后自动归属到办卡门店</span>
      </el-form-item>
      <el-form-item v-if="data.card_ticket_id" label="来源课次券">
        <router-link :to="RouteConfig.cardTicketDetail.to(data.card_ticket_id)" class="primary-color">
          {{ data.card_ticket && data.card_ticket.card_ticket_type_name ? data.card_ticket.card_ticket_type_name : '课次券' }} No.{{ data.card_ticket_id }}
        </router-link>
      </el-form-item>

      <template v-if="data.apply_administrator && Object.keys(data.apply_administrator).length">
        <el-form-item label="申请人">
          <v-avatar-nickname
            :value="data.apply_administrator.avatar"
            :nickname="data.apply_administrator.nickname"
            :avatar-size="36"
          />
        </el-form-item>

        <el-form-item v-if="data.review_administrator && Object.keys(data.review_administrator).length" label="审核人">
          <v-avatar-nickname
            :value="data.review_administrator.avatar"
            :nickname="data.review_administrator.nickname"
            :avatar-size="36"
          />
        </el-form-item>
      </template>

      <el-form-item v-else-if="data.add_administrator" label="办理人">
        <span v-if="data.is_system_issue" class="primary-color">{{ data.add_administrator.nickname }}</span>
        <v-avatar-nickname
          v-else
          :value="data.add_administrator.avatar"
          :nickname="data.add_administrator.nickname"
          :avatar-size="36"
        />
      </el-form-item>
      <el-form-item v-else label="办理人">
        <span class="info-color">{{ data.is_app ? '小程序购买，无办理人' : '系统自动发放，无办理人' }}</span>
      </el-form-item>

      <div class="form-section-title">备注</div>
      <el-form-item v-if="data.apply_remark" label="办理备注">{{ data.apply_remark }}</el-form-item>
      <el-form-item label="备注文件">
        <v-remark-file-list v-if="data.remark_files && data.remark_files.length" :files="data.remark_files"/>
        <span v-else class="info-color">未上传</span>
      </el-form-item>

      <template v-if="data.is_del">
        <div class="form-section-title">退券信息</div>
        <el-form-item label="退券时间">{{ data.is_del | timeToYmdHi }}</el-form-item>
        <el-form-item v-if="data.del_administrator" label="退券人">{{ data.del_administrator.nickname }}</el-form-item>
        <el-form-item label="退券原因">{{ data.del_remark || '未填写' }}</el-form-item>
      </template>

      <el-form-item>
        <el-button @click="RouteConfig.voucherList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/voucher';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';

export default {
  name: RouteConfig.voucherDetail.name,
  data: () => ({
    RouteConfig,
    isLoadFailed: false,
    data: {
      id: 0,
      add_time: 0,
      update_time: 0,
      student_id: 0,
      store_id: 0,
      limit_store_id: 0,
      is_store_limited: 0,
      limit_store_name: '',
      voucher_type_id: 0,
      voucher_type_name: '',
      valid_duration_seconds: 0,
      issue_type: 0,
      amount_in_cents: 0,
      expire_time: 0,
      use_time: 0,
      is_expired: false,
      is_del: 0,
      store_name: '',
      is_app: 0,
      source_name: '',
      store_source_name: '',
      add_administrator: null,
      is_system_issue: 0,
      card_ticket_id: 0,
      card_ticket: null,
      del_administrator: null,
      apply_administrator: null,
      review_administrator: null,
      apply_remark: '',
      remark_files: [],
      del_remark: '',
      is_unique: null,
      rule: '',
      card_charge_types: [],
    },
    student: {
      selfie: '',
      student_name: '',
      card_number: '',
      nickname: '',
      phone: '',
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    findVoucherIssueType,
    async fetchData() {
      this.isLoadFailed = false;
      const { isError, data } = await show(this.id);
      if (isError || !data) return this.isLoadFailed = true;

      const { data: localData } = this;
      const updateData = {};
      Object.keys(data).forEach(key => {
        if (key in localData) updateData[key] = data[key];
      });
      Object.assign(localData, updateData);

      if (data.student) {
        Object.assign(this.student, {
          selfie: data.student.selfie || '',
          student_name: data.student.student_name || '',
          card_number: data.student.card_number || '',
          nickname: data.student.nickname || '',
          phone: data.student.phone || '',
        });
      }
    },
  },
};
</script>

<style scoped>
/* 详情页限宽，避免整行过长、信息看着散 */
.voucher-detail-form {
  max-width: 760px;
}

.form-section-title {
  display: flex;
  align-items: center;
  margin: 22px 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #3a4051;
}

.form-section-title:first-of-type {
  margin-top: 0;
}

.form-section-title::before {
  content: '';
  width: 4px;
  height: 14px;
  margin-right: 8px;
  border-radius: 2px;
  background: linear-gradient(180deg, #ff2d78, #8a2be2);
}

/* 标签下方的补充说明单独一行，避免与标签贴在一起 */
.form-item-tip {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.6;
}
</style>
